import { TReducers } from 'store'
import React from 'react'
import { useSelector } from 'react-redux'
import { RouteProps } from 'react-router'
import { Navigate, Route } from 'react-router-dom'
import { cookies } from 'sharedKernel/cookies/behavior'
import { ROUTES } from 'sharedKernel/constants'
import { caixaUser } from 'sharedKernel/user/CaixaUser'
import { getCredLocalStorage } from 'sharedKernel/auth/credLocalStorage'

interface AuthRouteProps extends RouteProps {
  features?: string[]
}

export function AuthRoute({ features = [], ...props }: AuthRouteProps): JSX.Element {
  const isAuthenticated = useSelector((state: TReducers) => state.auth.isAuthenticated)
  let havePermission
  const userPermissions: string[] = []
  const userCookie = cookies.get('_perm')


  if (!isAuthenticated || cookies.get('_cred')?.data?.token === undefined) {
    return <Navigate to={ROUTES.USER_AUTH.LOGIN} />
  }

  if (userCookie !== undefined) {
    userCookie.features.forEach((permission) => {
      userPermissions.push(String(permission.code))
    })

    // Verificar se é Admin City Hall pelo company type
    const companyType = getCredLocalStorage()?.company?.type
    const isAdminCityHall = userPermissions.includes('admin city hall') || userPermissions.includes('admin_city_hall') || companyType?.type === "Admin City Hall"
    const isCityHall = companyType?.type === "City Hall"
    const isPublicAdministration = companyType?.type === "Public Administration"
    const isResolver = companyType?.type === "Resolver"

    if (caixaUser.isCaixaUser() && features.length > 0) {
      const caixaAllowedFeatures = ['idea', 'evaluation', 'caixa_employee', 'challenge']
      havePermission = features.some(feature => caixaAllowedFeatures.includes(feature))
    } else if (isAdminCityHall && features.length > 0) {
      // Admin City Hall pode acessar rotas que têm ADMIN_CITY_HALL nas features ou outras features que ele possui
      havePermission = features.some(feature => {
        const featureLower = feature.toLowerCase()
        const adminCityHallFeature = 'admin city hall'
        return featureLower === adminCityHallFeature || 
               userPermissions.includes(feature) ||
               userPermissions.includes(featureLower) ||
               userPermissions.some(perm => perm.toLowerCase() === featureLower)
      })
    } else if (isCityHall && features.length > 0) {
      havePermission = features.some(feature => {
        const featureLower = feature.toLowerCase()
        const cityHallFeature = 'city hall'
        return featureLower === cityHallFeature ||
               userPermissions.includes(feature) ||
               userPermissions.includes(featureLower) ||
               userPermissions.some(perm => perm.toLowerCase() === featureLower)
      })
    } else if (isPublicAdministration && features.length > 0) {
      havePermission = features.some(feature => {
        const featureLower = feature.toLowerCase()
        return featureLower === 'public administration' ||
               userPermissions.includes(feature) ||
               userPermissions.includes(featureLower) ||
               userPermissions.some(perm => perm.toLowerCase() === featureLower)
      })
    } else if (isResolver && features.length > 0) {
      havePermission = features.some(feature => {
        const featureLower = feature.toLowerCase()
        return featureLower === 'idea' ||
               userPermissions.includes(feature) ||
               userPermissions.includes(featureLower) ||
               userPermissions.some(perm => perm.toLowerCase() === featureLower)
      })
    } else {
      havePermission = features?.some((feature) => userPermissions.includes(feature)) ?? false
    }

    if (!havePermission && features && features.length > 0) {
      // Absolute path: `to="*"` is resolved RELATIVE to the current route, producing e.g.
      // /hub/user-config/* — which matches nothing and dead-ends. "/not-found" has no route of its
      // own, so it falls through to the top-level <Route path="*"> catch-all (NotFoundPage), the
      // same target this was always meant to reach. Mirrors libs/shared/src/auth/AuthRoute.
      return <Navigate to="/not-found" replace />
    }
  }
  
    return <Route {...props} />
}
